import { Device } from '@twilio/voice-sdk';
import { create } from 'zustand';
import { deviceOptions } from '../constants/device.constants';
import { DeviceStoreType } from '../types/store/device.types';

export const useDeviceStore = create<DeviceStoreType>((set) => ({
  device: null,
  initializeDevice: (token) =>
    set(() => {
      const twilioDevice = new Device(token, deviceOptions);
      twilioDevice.register();
      return { device: twilioDevice };
    }),
  updateDeviceToken: (device) => set({ device }),
  call: null,
  setCallState: (call) => set({ call }),
  acceptedTimestamp: '',
  updateAcceptedTimestamp: (acceptedTimestamp) => set({ acceptedTimestamp }),
  resetCall: () => set({ call: null, acceptedTimestamp: '' }),
}));
